import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonService } from "src/app/services/common.service";

@Component({
    selector:'app-poshvine-button',
    templateUrl:'./button.component.html',
    styleUrls:['./button.component.scss']
})
export class ButtonComponent{
    @Input() type:'primary'|'secondary'|'tertiary' = 'primary';
    @Input() size:'small'|'medium'|'large' = 'medium';
    @Input() text = '';
    @Input() mwidth = '';
    @Input() mheight = '';
    @Input() dwidth = '';
    @Input() mfntSize = '';
    @Input() dfntSize = '';
    @Input() dheight = '';
    @Input() isImageRight = false;
    @Input() isImageLeft = false;
    @Input() imageSrc = '';
    @Input() isDisabled = false;
    @Input() classes = '';
    @Input() fontSize = 'sm';
    @Input() custom : 'curved'| '' = '';
    @Output() clickEvent: EventEmitter<any>= new EventEmitter<any>();

    constructor(
        public _commonService: CommonService
    ){

    }
    onClick(param:any){
        this.clickEvent.emit(param);
    }
}
